import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { graphql } from '@apollo/client/react/hoc';
import { compose } from 'redux';
import Helmet from 'react-helmet';
import withUser from 'components/withUser';
import H1 from 'components/deprecated/legacyElements/H1';
import SignOutMutation from 'queries/mutations/SignOutMutation.gql';

class SignOutPage extends PureComponent {
  state = {
    redirect: false,
  };

  static contextTypes = {
    client: PropTypes.any,
  };

  componentDidMount() {
    this.props
      .signOut()
      .then(() => this.context.client.resetStore())
      .then(() => {
        if (navigator && navigator.serviceWorker)
          return navigator.serviceWorker.getRegistrations();
        return Promise.resolve([]); // navigator is undefined, return resolved promise
      })
      .then((registrations) => {
        registrations.forEach((reg) => reg.unregister());
        this.props.logout();
        this.setState({ redirect: true });
      });
  }

  render() {
    return (
      <div className="inset">
        <Helmet title="Sign out" />
        {this.state.redirect && (
          <Helmet>
            <meta
              httpEquiv="refresh"
              content={`0;url=${process.env.BASE_URL}`}
            />
          </Helmet>
        )}
        <H1 inset>Signing out...</H1>
      </div>
    );
  }
}

export default compose(
  graphql(SignOutMutation, { name: 'signOut' }),
  withUser
)(SignOutPage);
